import React from 'react';
import FormCard from './FormCard';
import { Image } from 'react-bootstrap';
import LightLogo from '../../images/light-logo.svg';

const LeftSection = ({ onFormSubmit, formData, onReset, isResultGenerated }) => {
  return (
    <div className="text-white d-flex flex-column align-items-start justify-content-center h-100 logo-section">
      <Image src={LightLogo} alt="" className="position-absolute logo-img" />
      <FormCard onFormSubmit={onFormSubmit} formData={formData} onReset={onReset} isResultGenerated={isResultGenerated} />
    </div>
  );
};

export default LeftSection;